import { Component } from "react";
import { RefreshCw } from "lucide-react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("KINGBULLISH UI error", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center font-body text-white" data-testid="app-error-fallback">
        <div className="glass glass-neon hud max-w-md rounded-2xl p-8">
          <div className="font-display text-[0.65rem] font-bold tracking-[0.3em] text-neon">SYSTEM NOTICE</div>
          <h1 className="mt-3 font-display text-2xl font-black italic tracking-tight">SOMETHING WENT WRONG</h1>
          <p className="mt-3 text-base font-medium text-white/70">
            The page hit an unexpected error. Reload to get back to the KINGBULLISH ecosystem.
          </p>
          <button type="button" onClick={() => window.location.reload()} className="btn-neon mt-6" data-testid="app-error-reload">
            RELOAD PAGE <RefreshCw className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }
}
